<ng-container *ngIf="!isLoading">
  <div fxLayout fxLayoutAlign="center center" class="header-title">
    <span><b>Customer Review</b></span>
  </div>
  <br />
  <div fxLayout="row" fxLayoutGap="5pt" fxLayoutAlign="start start">
    <div fxFlex="50" fxLayout="column" fxLayoutGap="5pt">
      <span><b>Comments: </b></span>
      <div fxLayout="row" fxLayoutGap="5px" class="table-headers">
        <div fxFlex="25">
          <span><b>Name</b></span>
        </div>
        <div fxFlex="25">
          <span><b>Date</b></span>
        </div>
        <div fxFlex="50">
          <span><b>Comment</b></span>
        </div>
      </div>
      <ng-container
        *ngFor="let shipmentReview of shipmentReviews; let i = index"
      >
        <div fxLayout="row" fxLayoutGap="5px">
          <div fxFlex="25">
            <span>{{ shipmentReview.createUser }}</span>
          </div>
          <div fxFlex="25">
            <span>{{ shipmentReview.createDate | date : "MM/dd/yyyy" }}</span>
          </div>
          <div fxFlex="50">
            <span>{{ shipmentReview.comment }}</span>
          </div>
        </div>
      </ng-container>
    </div>
    <form
      fxFlex="50"
      fxLayout="column"
      fxLayoutGap="10pt"
      [formGroup]="customerReviewForm"
    >
      <div fxLayout="row" fxLayoutGap="10pt">
        <div fxFlex="50" fxLayout="column">
          <mat-form-field>
            <mat-label>Comments</mat-label>
            <textarea
              matInput
              formControlName="Comment"
              required
              rows="6"
            ></textarea>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxLayout="column" fxLayoutGap="3px">
          <app-imperia-select
            [matLabel]="'Customer Review Status'"
            [options]="customerReviewStatus"
            [formControlName]="'CustomerReviewStatusID'"
            [searchCriteria]="'customerReviewStatusDescription'"
            [valueKey]="'id'"
            [displayKey]="'customerReviewStatusDescription'"
          >
          </app-imperia-select>
          <app-imperia-select
            [matLabel]="'Direction'"
            [options]="directions"
            [formControlName]="'DirectionID'"
            [searchCriteria]="'DirectionsDesc'"
            [valueKey]="'DirectionsID'"
            [displayKey]="'DirectionsDesc'"
          >
          </app-imperia-select>
          <app-imperia-select
            [matLabel]="'Expense Code'"
            [options]="expenseCodes"
            [formControlName]="'ExpenseCodesID'"
            [searchCriteria]="'ExpDesc'"
            [valueKey]="'ExpCodesID'"
            [displayKey]="'ExpDesc'"
          >
          </app-imperia-select>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5pt">
        <button
          mat-flat-button
          type="button"
          color="accent"
          [mat-dialog-close]="false"
        >
          Exit
        </button>
        <button
          mat-flat-button
          type="submit"
          class="orange"
          [disabled]="!customerReviewForm.valid"
          (click)="updateCustomerReview()"
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</ng-container>
<div *ngIf="isLoading">
  <h3 mat-dialog-title>Loading...</h3>
  <div fxLayout="row" fxLayoutAlign="center center">
    <app-loading [isRelative]="true"></app-loading>
  </div>
</div>
